import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth"; // Shared utility
import ApiPath from "./ConstantApi";

export const RolesService = createApi({
  reducerPath: "RolesApi",
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ""), // Use shared base query
  tagTypes: ["Roles"],
  endpoints: (builder) => ({
    getRoleList: builder.query<any, any>({
      query: (reqBody) => ({
        url: `${ApiPath.getRoleList}?page=${reqBody.page}&pageSize=${reqBody.pageSize}`,
        method: "GET",
      }),
      providesTags: ["Roles"],
    }),
    getRolePermissionByRoleId: builder.query({
      query: (roleId: string) => `${ApiPath.getPermissionById}/${roleId}`,
      transformResponse: (response: { data: any }) => response.data,
    }),
    getEmployeeByRoleId: builder.query({
      query: (roleId: string) => `${ApiPath.getEmployeeByRoleId}/${roleId}`,
      transformResponse: (response: { data: any[] }) =>
        response.data[0]["employees"],
    }),
    createRole: builder.mutation<any, any>({
      query: (reqBody) => ({
        url: `${ApiPath.createRole}`,
        method: "POST",
        body: reqBody,
      }),
      invalidatesTags: ["Roles"],
    }),
    updateRole: builder.mutation<any, any>({
      query: (obj: any) => ({
        url: `${ApiPath.updateRole}/${obj.roleId}`,
        method: "PUT",
        body: obj.reqBody,
      }),

      invalidatesTags: ["Roles"],
    }),
    logoutUser: builder.mutation<any, any>({
      query: (refreshToken) => ({
        url: `${ApiPath.logoutUser}?refreshToken=${refreshToken}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetRoleListQuery,
  useLazyGetRoleListQuery,
  useLazyGetRolePermissionByRoleIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useLazyGetEmployeeByRoleIdQuery,
  useLogoutUserMutation,
} = RolesService;
